import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const Ttbf003cp = () => {
  return (
    <div className='mx-auto mt-5 max-w-[1440px] lg_mt-[0px]'>
      <div className='flex flex-col gap-y-2'>
        <picture>
          <source
            media='(max-width: 959px)'
            srcSet='/images/ttbf003/1-m.jpg'
            width={800}
            height={750}
          />
          <source
            media='(min-width: 960px)'
            srcSet='/images/ttbf003/1.jpg'
            width={1464}
            height={750}
          />
          <img
            alt=''
            className='h-auto w-full'
          />
        </picture>
        <picture>
          <source
            media='(max-width: 959px)'
            srcSet='/images/ttbf003/2-m.jpg'
            width={800}
            height={1135}
          />
          <source
            media='(min-width: 960px)'
            srcSet='/images/ttbf003/2.jpg'
            width={1464}
            height={1550}
          />
          <img
            alt=''
            className='h-auto w-full'
          />
        </picture>
        <picture>
          <source
            media='(max-width: 959px)'
            srcSet='/images/ttbf003/3-m.jpg'
            width={800}
            height={1115}
          />
          <source
            media='(min-width: 960px)'
            srcSet='/images/ttbf003/3.jpg'
            width={1464}
            height={700}
          />
          <img
            alt=''
            className='h-auto w-full'
          />
        </picture>
      </div>

      <div className='px-[17px] lg_px-0'>
        <h2 className='py-[20px] text-center font-poppins text-[24px]'>Frequently Asked Questions</h2>
        <Accordion
          type='multiple'
          className='mt-[20px] w-full border-t border-[#EFEFEF] lg_mt-[40px]'
          defaultValue={[]}
        >
          <AccordionItem value='item-1'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>How does the smart bird feeder work?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                This feeder uses a built-in HD camera and motion sensor to automatically capture videos and photos of
                visiting birds. Once a bird lands, it starts recording and sends real-time notifications to your phone
                through WiFi, allowing you to watch live anytime.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-2'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Can I identify the bird species in the app?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes! The feeder is powered by AI that can recognize over 10,000 bird species. The app displays the
                species name instantly, helping both beginners and enthusiasts learn more about the birds they attract.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-3'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Do I need to pay for the AI features?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Some advanced AI features require a subscription, but new users receive a 30-day free trial. Even
                without a subscription, you can still enjoy live viewing, photo/video recording, and sharing functions.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-4'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>How does the solar power system work?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                It comes with a 3W solar panel and a 5200mAh rechargeable battery. The solar panel provides continuous
                power in sunny weather, and you can also charge it via USB-C on cloudy days or during long winters.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-5'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Is the feeder weatherproof?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes. The feeder has an IP65 waterproof rating, protecting it from rain, snow, and dust. Its metal
                housing and anti-rust coating make it suitable for year-round outdoor use.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-6'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Can squirrels get into the feeder?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Not easily. The 1.5-inch metal mesh cage keeps larger animals like squirrels out while allowing small
                and medium birds to feed comfortably.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-7'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>How far can the WiFi connection reach?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                The enhanced 5dBi antenna provides a stable WiFi signal up to 200 meters in open areas, ensuring smooth
                live streaming and real-time notifications.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-8'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>What types of food can I use with this feeder?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                You can fill it with mealworms, mixed seeds, nuts, or small suet pieces—perfect for attracting
                songbirds, bluebirds, chickadees, and other small backyard species.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-9'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>Can I share the live feed with family or friends?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Absolutely! The app allows multiple users to view the live stream at the same time. It’s a great way to
                share birdwatching moments with your loved ones or post them on social media.
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-10'>
            <AccordionTrigger className='h-[70px] border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px]'>
              <h2 className='pr-[40px]'>How are the recordings stored?</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                You can store videos either in the cloud (with 3-day looping and a 2-year free trial) or on a microSD
                card up to 128GB (not included), giving you flexible storage options.
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default Ttbf003cp;
